export default "__VITE_ASSET__BTwGDbO0__"